import { FC } from "react";

import Sidebar from "../Sidebar/Sidebar";
import { Container } from "./UsersManagementAdminStyles";
import UsersManagementStepAdmin from "./UsersManagementStepAdmin";
interface IUsersManagementAdminSidebar {
  toggleModal: any;
  dataUserEditAdmin: any;
  setShowModalSuccessRegister: any;
  setMessageSuccessRegister: any;
  setTitleMessageUsers: any;
  userProfileMe: any;
}
const UsersManagementAdminSidebar: FC<IUsersManagementAdminSidebar> = (
  props
) => {
  const {
    toggleModal,
    dataUserEditAdmin,
    setShowModalSuccessRegister,
    setMessageSuccessRegister,
    setTitleMessageUsers,
    userProfileMe,
  } = props;
  return (
    <Sidebar onOutsideClick={toggleModal}>
      <Container>
        <UsersManagementStepAdmin
          dataUserEditAdmin={dataUserEditAdmin}
          toggleModal={toggleModal}
          userProfileMe={userProfileMe}
          setShowModalSuccessRegister={setShowModalSuccessRegister}
          setMessageSuccessRegister={setMessageSuccessRegister}
          setTitleMessageUsers={setTitleMessageUsers}
        />
      </Container>
    </Sidebar>
  );
};

export default UsersManagementAdminSidebar;
